import React from 'react';
import PropTypes from 'prop-types';
import I18n from '@/rI18n';
import McpCatalogListItem from './McpCatalogListItem';

export default function McpCatalogList({ items, onDelete, onItemClick }) {
    if (items.length === 0) {
        return <div className="mcp-catalog-empty"></div>;
    }

    return (
        <ul className="mcp-catalog-list">
            {items.map(item => (
                <McpCatalogListItem
                    key={item.id}
                    item={item}
                    onDelete={onDelete}
                    onItemClick={onItemClick}
                />
            ))}
        </ul>
    );
}

McpCatalogList.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            mcpName: PropTypes.string.isRequired
        })
    ).isRequired,
    onDelete: PropTypes.func.isRequired,
    onItemClick: PropTypes.func.isRequired
};
